<template>
  <form ref="form">
    <div class="question-text" v-html="getQuestionText"></div>
    <div v-for="(choice, index) in data.choices" :key="index">
      <div class="input-group" :class="isChecked(choice.id)">
        <label :for="`input_checkbox_${choice.id}`" @click="selected(choice)">
          <span v-html="getChoiceText(choice.id)">{{choice.text}}</span>
          <input
            type="text"
            :name="`input[${choice.id}]`"
            :id="`input_${choice.id}`"
            :ref="`input_${choice.id}`"
            @keyup="setCustomValue(choice)"
          >
        </label>
      </div>
    </div>

    <button type="button" class="previous" @click="prev">Previous</button>
    <button
      @click.prevent="next"
      :disabled="nextBtnDisabled"
      :class="{ active: !nextBtnDisabled }"
      class="next"
    >Next</button>

    <!--<p>{{ nextBtnDisabled }}</p>-->

  </form>
</template>

<script>
export default {
    name: 'input-textline',

    props: {
      data: {
        required: true,
        type: Object
      }
    },

    data() {
        return {
            nextBtnDisabled: true,
            answer: {
              question: this.data.id,
              choices: []
            },
            customValue: '',
        }
    },

    methods: {
        selected(choice) {
            let index = this.answer.choices.findIndex(c => c.id === choice.id)
            this.answer.choices[index].custom = this.customValue;
            this.customValue = '';
        },

        setCustomValue(choice) {
            if ( this.$refs[`input_${choice.id}`][0].value.trim() !== '' ){
              this.customValue = this.$refs[`input_${choice.id}`][0].value.trim()
              this.selected(choice)
            }
        },

        next() {
            this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question');
        },

        isChecked(choiceId) {
          const index = this.answer.choices.findIndex(c => c.id === choiceId);
          if ( this.answer.choices[index].custom && this.answer.choices[index].custom.length > 0 ){
            return 'active';
          }
          return '';
        },

        getChoiceText(choiceId) {
          const index = this.data.choices.findIndex(c => c.id == choiceId);
          const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
          return this.data.choices[index].text[textIndex].html;
        }
    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      }
    },

    watch: {
      'answer.choices': function(val) {
        // must check if mandatory and customs not empty
        console.log(val.length)
        if( val.length > 0){
          this.nextBtnDisabled = false
        } else {
          this.nextBtnDisabled = true
        }
      }
    },

    created() {
      this.data.choices.forEach(choice => {
        this.answer.choices.push({
          'id': choice.id,
          'custom': null
        })
      })
    }
}
</script>